import { useState, useEffect } from 'react';
import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

const IMPROVE_NOTIFICATION_EXPERIENCE_TEST_NAME = 'improveNotificationExperience_Feb2026';

let userNotificationsTestHasBeenTracked = false;

export const useUpdatedNotificationContentVariant = (): boolean => {
    const [isUpdatedNotificationContentVariant, setIsUpdatedNotificationContentVariant] =
        useState(false);

    useEffect(() => {
        const isVariant =
            getAbTestV2(IMPROVE_NOTIFICATION_EXPERIENCE_TEST_NAME)?.variant === 'variant';
        setIsUpdatedNotificationContentVariant(isVariant);
    }, []);

    return isUpdatedNotificationContentVariant;
};

export const isUpdatedNotificationContentVariant = (): boolean => {
    return getAbTestV2(IMPROVE_NOTIFICATION_EXPERIENCE_TEST_NAME)?.variant === 'variant';
};

export const trackUpdatedNotificationContentVariant = (): void => {
    if (userNotificationsTestHasBeenTracked) {
        return;
    }

    userNotificationsTestHasBeenTracked = true;
    trackAbTestV2Variant(IMPROVE_NOTIFICATION_EXPERIENCE_TEST_NAME);
};
